export default __webpack_public_path__ + "static/media/cart_empty.90464560.svg";